import { ticketGetDescription as description } from './description';
import { getTicket as execute } from './execute';

export { description, execute };
